// Constant data for Merchant::Inbound::Pickup

export const COURIER = {
  ALFATRAX    : 'alfatrax',
  GOJEK       : 'gojek',
  JNE         : 'jne',
  GRAB        : 'grab',
  TIKI        : 'tiki',
  PCP_EXPRESS : 'pcp_express'
}